import { state_ctrl_factory } from 'ww2_analytics/common/state_ctrl';
import { inject_rb_form } from '../form';

const main_view = {
    template: require('./view.html'),
    controller: state_ctrl_factory('runner_battler_api', function(service_api, $scope, model) {
        service_api.get_total_install_count(model).then(resp => $scope.vm.total_install_count = resp);
    }),
};
const state_config = inject_rb_form({
    url: '/retention_short',
    reloadOnSearch: false,
    data: {
        title: 'Retention Short',
    },
    views: {
        '': main_view,
    },
});
export default state_config;
